/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MSP04DataDto { 
    sno?: string | null;
    rvalue?: string | null;
    typeOfLoan?: string | null;
    numOfBorrowers?: number | null;
    outstandingLoanAmt?: number | null;
    weightedAvgIntRateSLA?: number | null;
    normalIntRateSLALowest?: number | null;
    normalIntRateSLAHeighest?: number | null;
    weightedAvgIntRateRBA?: number | null;
    normalIntRateRBALowest?: number | null;
    normalIntRateRBAHeighest?: number | null;
}

